export const normalizePaymentStatus = (status) => {
  const legacyStatuses = {
    awaiting_confirmation: 'pending',
    authorized: 'pending',
    partially_paid: 'pending',
    failed: 'pending',
    rejected: 'pending',
    voided: 'pending',
    confirmed: 'collected',
    partially_refunded: 'paid'
  };

  return legacyStatuses[status] || status || 'pending';
};

export const getPaymentDisplay = (payment = {}) => {
  const refundedAmount = Number(payment.refunded_amount || 0);
  const status = normalizePaymentStatus(payment.status);

  if (
    (refundedAmount > 0 || payment.status === 'partially_refunded')
    && status !== 'refunded'
  ) {
    return { label: 'Partially refunded', badgeStatus: 'attention' };
  }

  const labels = {
    pending: 'Pending',
    paid: 'Paid',
    collected: 'Collected',
    refunded: 'Refunded'
  };
  const badgeStatuses = {
    pending: 'warning',
    paid: 'success',
    collected: 'success',
    refunded: 'info'
  };

  return {
    label: labels[status] || status,
    badgeStatus: badgeStatuses[status] || 'warning'
  };
};
